import { Link } from "react-router-dom";
import { Reveal, Overline } from "./Reveal";

export const PageHero = ({ overline, title, subtitle, image }) => (
  <section className="relative pt-40 pb-20 sm:pb-24 overflow-hidden">
    {image && (
      <div className="absolute inset-0 z-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#09090b]/80 via-[#09090b]/90 to-[#09090b]" />
      </div>
    )}
    <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
      <Reveal>
        <Overline>{overline}</Overline>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-lg text-[#A1A1AA] max-w-2xl leading-relaxed">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);

export const CTASection = () => (
  <section className="py-24 sm:py-32 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <div className="bg-gradient-to-br from-[#1a1105] to-[#111113] border border-[#D97736]/20 rounded-sm p-10 sm:p-16 text-center">
          <Overline>Iniziamo</Overline>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold max-w-3xl mx-auto">
            Hai un locale, un evento o un progetto da far crescere?
          </h2>
          <p className="mt-6 text-[#A1A1AA] max-w-xl mx-auto text-lg">
            Raccontami cosa ti serve: ti ricontatto io con una proposta su misura.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contatti"
              data-testid="cta-preventivo-button"
              className="bg-[#D97736] text-white px-8 py-4 rounded-sm font-semibold tracking-wide hover:bg-[#B85B22] transition-all shadow-[0_0_25px_rgba(217,119,54,0.3)]"
            >
              Richiedi un preventivo
            </Link>
            <Link
              to="/contatti"
              data-testid="cta-call-button"
              className="border border-white/20 text-white px-8 py-4 rounded-sm font-semibold tracking-wide hover:border-[#D97736] hover:text-[#D97736] transition-colors"
            >
              Prenota una call
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
